module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"errorText":"Возникли трудности с подключением. Производится попытка переподключения... Проверьте ваше соединение с интернетом.","safariChangeMic":"Вы подключили новое устройство. Происходит настройка..."}}')
  delete Component.options._Ctor
}
